import React, { useEffect, useState } from "react";
import { FaUser, FaPhone, FaEnvelope } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { EDIT_INSPECTOR_DETAILS } from "../../utils/RouteConstant";
import Breadcrumbs from "../../customComponent/BreadCrumbs";
import { ImageBaseUrl, breadcrumbNameMap } from "../../utils/helperData";
import { AiOutlineDownload } from "react-icons/ai";
import { BiEdit } from "react-icons/bi";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { RiLockPasswordFill } from "react-icons/ri";
import { Tab } from "@headlessui/react";
import OngoingProject from "./OngoingProject";
import PastProject from "./PastProject";
import AssignProjects from "./AssignProjects";
import { useDispatch, useSelector } from "react-redux";
import { GetInspectorsDetails } from "../../../redux/action/InspectorManagement/AddInspectorAction";
import file_image from "../../../asesst/file_image.png";
import { FaUserCog } from "react-icons/fa";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ViewInspectorDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const { inspectorId } = useParams();
  const inspectorDetails = useSelector(
    (state) => state.inspector.inspectorDetails
  );
  useEffect(() => {
    if (inspectorId) {
      dispatch(GetInspectorsDetails(inspectorId));
    }
  }, [inspectorId]);

  const [categories] = useState({
    "Personal Details": [],
    "Assigned Projects": [],
    "Ongoing Projects": [],
    "Past Projects": [],
  });

  useEffect(() => {
    if (location.state?.selectedTab === "Assigned Projects") {
      setSelectedTabIndex(1);
    }
    if (location.state?.selectedTab === "Ongoing Projects") {
      setSelectedTabIndex(2);
    }
    if (location.state?.selectedTab === "Past Projects") {
      setSelectedTabIndex(3);
    }
  }, [location.state]);

  const handleEditInspector = () => {
    if (inspectorId) {
      navigate(`${EDIT_INSPECTOR_DETAILS}/${inspectorId}`);
    }
  };
  const tabNames = [
    "Project Details",
    "Assigned Projects",
    "Ongoing Projects",
    "Past Projects",
  ];

  useEffect(() => {
    if (location.state && location.state.selectedTab) {
      const tabIndex = tabNames.indexOf(location.state.selectedTab);
      if (tabIndex !== -1) {
        setSelectedTabIndex(tabIndex);
      }
    }
  }, [location.state]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const downloadDocument = async (image) => {
    const url = `${ImageBaseUrl}${image}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.setAttribute("download", image);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading document:", error);
    }
  };

  const truncateString = (str) => {
    if (str?.length > 15) {
      return str.slice(0, 15) + "...";
    }
    return str;
  };
  return (
    <div>
      <h2 className="text-3xl font-bold mb-6">User Management</h2>
      <div className="flex justify-between items-center">
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
        {selectedTabIndex === 0 && (
          <button
            onClick={handleEditInspector}
            className="bg-[#1C3664] text-white px-4 py-2 rounded-lg flex items-center hover:bg-blue-900"
          >
            <BiEdit className="mr-2" />
            Edit Details
          </button>
        )}
      </div>

      <Tab.Group
        selectedIndex={selectedTabIndex}
        onChange={setSelectedTabIndex}
      >
        <Tab.List className="flex space-x-1 rounded-t-xl bg-blue-900/20 p-1 mt-8">
          {Object.keys(categories).map((category) => (
            <Tab
              key={category}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                  selected
                    ? "bg-white shadow"
                    : "text-blue-100 hover:bg-white/[0.52] hover:text-black"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        {/* <h2>Inspector Details for ID: {inspectorId}</h2> */}
        <Tab.Panels className="mx-auto bg-white shadow-lg rounded-b-xl p-8">
          <Tab.Panel>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
              <div>
                <div className="flex">
                  <div>
                    <FaUser className="text-[#1C3664] mr-3 mt-[1px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    First Name
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {inspectorDetails?.first_name}
                </div>
              </div>

              <div>
                <div className="flex">
                  <div>
                    <FaUser className="text-[#1C3664] mr-3 mt-[1px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Last Name
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {inspectorDetails?.last_name || "-"}
                </div>
              </div>

              <div>
                <div className="flex">
                  <div>
                    <FaPhone className="text-[#1C3664] mr-3 mt-[1px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Phone Number
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {/* (972) 2313 578 */}
                  {inspectorDetails?.mobile}
                </div>
              </div>

              <div>
                <div className="flex">
                  <div>
                    <FaEnvelope className="text-[#1C3664] mr-3 mt-[1px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Email
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {inspectorDetails?.email}
                </div>
              </div>
              <div>
                <div className="flex">
                  <div>
                    <FaUserCog className="text-[#1C3664] mr-3 mt-[1px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Role type
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-3">
                  {inspectorDetails?.user_type === 2
                    ? "User"
                    : inspectorDetails?.user_type === 3
                    ? "Inspector"
                    : "-"}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  mt-12 gap-6 mb-6">
              <div>
                <div className="flex">
                  <div>
                    <BusinessCenterIcon className="text-[#1C3664] mr-3 mb-[10px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Employment ID
                  </div>
                </div>
                <div className="text-base text-[#626262] font-light mt-1">
                  {inspectorDetails?.employee_id}
                </div>
              </div>
              {/* <div>
                <div className="flex">
                  <div>
                    <RiLockPasswordFill className="text-[#1C3664] mr-3 mt-[3px]" />
                  </div>
                  <div className="text-base font-semibold text-[#1C3664]">
                    Default Password
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-base text-[#626262] font-light mt-3">
                    {showPassword ? inspectorDetails?.password : "********"}
                  </div>
                  <button
                    onClick={togglePasswordVisibility}
                    className="text-blue-600 ml-2 cursor-pointer"
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </div> */}
            </div>

            {inspectorDetails?.supporting_doc?.length > 0 ? (
              <div className="mt-12">
                <h3 className="text-xl font-semibold mb-4">
                  Inspector Documents
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {inspectorDetails?.supporting_doc?.map((image, key) => (
                    <div
                      key={key}
                      className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
                    >
                      <div className="flex items-center space-x-3">
                        <img
                          src={file_image}
                          alt="Inspector Document"
                          className="w-12 h-12 rounded-lg"
                        />
                        <div>
                          <p className="font-semibold">
                            {" "}
                            {truncateString(image)}
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={() => downloadDocument(image)}
                        className="text-[#1C3664]"
                      >
                        <AiOutlineDownload size={24} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <p></p>
            )}
          </Tab.Panel>

          <Tab.Panel>
            <AssignProjects />
          </Tab.Panel>

          <Tab.Panel>
            <OngoingProject />
          </Tab.Panel>

          <Tab.Panel>
            <PastProject />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ViewInspectorDetails;
